import useApiQuery from 'shared/hooks/use-api-query';
import {UserProps} from '../types';

const useUsersSelect = <T = any>() => {
  const {data = [], ...query} = useApiQuery<UserProps[]>({
    url: '/users/all',
  });

  return {
    ...query,
    data: data.map((user) => ({
      label: `${user.name} - ${user.email}`,
      value: user.id,
    })),
  };
};

export default useUsersSelect;
